module.exports = __webpack_public_path__ + "static/sift-rules-bf40eb85354717f55a14ea521ab06838.png";